
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shops/[category]/[keyword]",
      function () {
        return require("private-next-pages/shops/[category]/[keyword].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shops/[category]/[keyword]"])
      });
    }
  